import { jsonGET } from "@iva/rest-service-utils";
import { action as createAction } from "@iva/store-utils";
import { Dispatch } from "redux";
import { NIL } from "uuid";
import { GetState, ThunkResult } from "#store/types";
import { fetchInterpretationFromServer } from "#store/interpretations";
import {
    EnvironmentActionTypes,
    EnvironmentState,
    LoadEnvironmentErrorAction,
    LoadEnvironmentSuccessAction,
    UpdateEnvironmentAction,
} from "#store/environment/environmentTypes";
import { generateNewUserId } from "#store/ui/uiActions";
import { loadDatasources } from "#store/datasources";

export const loadEnvironment =
    (): ThunkResult<void> => (dispatch: Dispatch, getState: GetState) => {
        // Dispatch action that fetching data has begun
        dispatch(createAction(EnvironmentActionTypes.LOAD_START, undefined));

        // Call endpoint, dispatch success- or error-message, depending on server response
        // Submit the GET-request, expecting plain text as response type
        jsonGET(
            "/odd3/env.json",
            result => {
                dispatch(
                    updateEnvironment(result as Partial<EnvironmentState>)
                );
                dispatch(loadEnvironmentSuccess());
                dispatch(loadDatasources());

                if (getState().uiState.rid === NIL) {
                    dispatch(generateNewUserId());
                }

                getState().uiState.activeInterpretations.forEach(
                    interpretationId => {
                        dispatch(
                            fetchInterpretationFromServer(interpretationId)
                        );
                    }
                );
            },
            error => {
                dispatch(loadEnvironmentFailed(error.message));
            }
        );
    };

export function updateEnvironment(
    data: Partial<EnvironmentState>
): UpdateEnvironmentAction {
    return createAction(EnvironmentActionTypes.UPDATE_ENVIRONMENT, data);
}

export function loadEnvironmentSuccess(): LoadEnvironmentSuccessAction {
    return createAction(EnvironmentActionTypes.LOAD_SUCCESS, undefined);
}

export function loadEnvironmentFailed(
    error: unknown | undefined
): LoadEnvironmentErrorAction {
    return createAction(EnvironmentActionTypes.LOAD_ERROR, error);
}
